export class AuthOperadora{

    static ID_OPERADORA(){
        try {
            return Number(window.localStorage.getItem('id_operadora'))
        } catch (error) {
            return 0
        }
    }

    static CODIGO_SICAH(){
        try {
            return window.localStorage.getItem('codigo_sicah')
        } catch (error) {
            return 0
        }
    }

    static EMPRESA(){
        let empresa = Number(window.localStorage.getItem('id_operadora'))
        try {
            return (!!empresa)
        } catch (error) {
            return false            
        }
    }

    static FILTER(){

        if(this.EMPRESA()){
            return `&filter[empresa_id]=${this.ID_OPERADORA()}`
        }
        return ''

    }
}